import AppModal from "components/Modal"; 
import React, { 
    useEffect, 
    useState, 
}  from 'react';
import ReactDOM from "react-dom"; 
import { useAuth } from '../../../helpers/authContext';

import {
    // Alert,
    Button, 
  Card,
  CardBody,
  Col,   
  FormGroup,
  Input,
  Row, 
} from "reactstrap"; 
import { useToast } from "components/ui/use-toast"; 
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal"; 
import { isLoggedWithKeychain, numberWithCommas } from "services/dsteem-service";
import { powerDownKeychain  } from "helpers/keychain";
import { powerDownWithWif, vests2SP  } from "helpers/steem"; 
import { getUser } from "services/user-service"; 
type Props = {
  isShowing: boolean,
  cancel?: boolean,
  hide: any,  
  symbol?:string,
  mvest:any,
  onSuccess?: () => void;
} 
export const PowerDownModal = ({ isShowing, hide,  symbol="STEEM",mvest, cancel = false, onSuccess = null}: Props) => { 
    const { user, autologin } = useAuth(); 
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const [isCanceling, setIsCanceling] = useState(false); 
    const keychainLogin = isLoggedWithKeychain(autologin); 
    const [availableSP, setAvailableSP] = useState<any>(0); 
    const [transferAmount, setTransferAmount] = useState<any>(0); 
    const [step, setStep] = useState<any>(1);
    const [showConfirm, setShowConfirm] = useState(false);
    const [transferSymbol, setTransferSymbol] = useState<any>(symbol); 
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    useEffect(()=> { 
        async function getAvailableFunds (){
            try {
                const [userInfo] = await Promise.all([ 
                    getUser(user),
                ]); 
                let sp = vests2SP(userInfo.vesting_shares, mvest) || 0.000;
                let delegated = vests2SP(userInfo.delegated_vesting_shares, mvest) || 0.000;
                let received = vests2SP(userInfo.received_vesting_shares, mvest) || 0.000;
                let pd = vests2SP(userInfo.vesting_withdraw_rate, mvest) || 0.000;
                let totalSP:any = parseFloat((sp - delegated - pd + received).toFixed(3)) || 0.000;
                setAvailableSP(parseFloat(totalSP) || 0)
            } catch (error) {
                toast({title:"Error", description:error, variant:"rose_red"});
            }
            
        }
        getAvailableFunds();  
    },[isShowing]); 


    const handlePD = async (newWif = "") => { 
        // if (transferAmount) { 
            const fn = keychainLogin ? powerDownKeychain : powerDownWithWif;
            const account = keychainLogin ? user : autologin; 
            setIsCanceling(true);
            let res:any = await fn(account, transferAmount,mvest, newWif);
            setIsCanceling(false);
            if (!res.success) { 
                if(res?.message.toString().includes("Missing Active Authority")){ 
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                } else {
                   toast({
                        title:"Failed starting power down.",
                        description:res,
                        variant:"rose_red"
                    }); 
                }
                
            }else {
                toast({
                title:cancel? "Power down stopped successfully.":"Power down started successfully.",
                description:cancel?"You have stopped your Power Down.":"You have started a Power Down.",
                variant:"wild_green"
                }); 
                setTransferAmount(0); 
                setStep(1);
                setShowConfirm(false);
                if (onSuccess) {
                    onSuccess();
                } 
                hide();
            }
        // }else{
        //     toast({
        //         title:"Failed sending funds.",
        //         description:"You need to set an amount.",
        //         variant:"rose_red"
        //     });
        // }
    }
    const setByPercent = (percent: number) => {
        const amount = parseFloat(((availableSP * percent) / 100).toFixed(3));
        setTransferAmount(amount);
    };

    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0">
            {user && (
                <CardBody className="px-lg-3 py-lg-3 body-gray"> 
                    {step == 1 && (
                        <Row>
                            <Col md="12">
                                {cancel ? (
                                    <div className="text-center py-4">
                                        <i className="fas fa-power-off fa-3x mb-3 text-danger" />
                                        <h5>Stop Power Down</h5>
                                        <p className="promotion-description">
                                            You are about to stop your current Steem Power withdrawal process. This will cancel any upcoming weekly payments from your power down.
                                        </p>
                                    </div>
                                ) : (
                                    <p className="promotion-description">
                                        <b>Withdraw Steem Power.</b> Starting a Power Down will allow you to convert your Steem Power into liquid Steem. This process takes four weeks and you will receive a quarter each week.
                                    </p>
                                )}
                            </Col>
                            {!cancel && (
                                <>
                                    <Col  className="col-8" md="8"> 
                                        <FormGroup>
                                            <div className="input-icon-group">
                                                <i className="fas fa-coins input-icon" />
                                                <input type="number" className="form-control fancy-input" name="val" placeholder="Amount (SP)" value={transferAmount} onChange={(e) => {
                                                    let val = parseFloat(e.target.value);
                                                    if (val > availableSP) val = availableSP;
                                                    if (val < 0) val = 0;
                                                    setTransferAmount(val);
                                                    }}
                                                />
                                            </div>
                                        </FormGroup> 
                                    </Col>
                                    <Col className="col-4" md="4"> 
                                        <Input type="select" className="form-control fancy-input mb-3" name="symbol" value={transferSymbol} onChange={(e) => setTransferSymbol(e.target.value)} >
                                            <option value="STEEM">SP</option> 
                                        </Input> 
                                    </Col>
                                    <Col md="12" className="mb-3">
                                        <small className="text-muted d-flex justify-content-between">
                                            <span>Available: <b>{numberWithCommas(availableSP.toFixed(3))} SP</b></span>
                                            <span>{transferAmount ? ((transferAmount / availableSP) * 100).toFixed(0) : 0}%</span>
                                        </small>

                                        {/* Slider */}
                                        <input
                                            type="range"
                                            min={0}
                                            max={availableSP}
                                            step={0.001}
                                            value={transferAmount}
                                            onChange={(e) => setTransferAmount(parseFloat(e.target.value))}
                                            className="form-range w-100"
                                        />

                                        {/* Quick percent buttons */}
                                        <div className="d-flex justify-content-between mt-2">
                                            {[0, 25, 50, 75, 100].map((p) => (
                                            <Button
                                                key={p}
                                                size="sm"
                                                color={transferAmount === (availableSP * p) / 100 ? "primary" : "secondary"}
                                                outline
                                                onClick={() => setByPercent(p)}
                                            >
                                                {p}%
                                            </Button>
                                            ))}
                                        </div>
                                    </Col>
                                </>
                            )}
                            <Col md="12"> 
                                <Button color={cancel ? "danger" : "default"} className="w-100 btn-fancy" onClick={() => {
                                    if (cancel || (transferAmount && transferSymbol)) {
                                        setShowConfirm(true);
                                    }else {
                                        toast({title:"Fill all fields first", description:"Set a proper  amount.", variant:"rose_red"});
                                    }
                                }}>
                                    {cancel ? "Stop Power Down" : "Next"} <i className={`fas fa-${cancel ? "power-off" : "chevron-right"} ml-2`} />
                                </Button> 
                            </Col>
                        </Row>
                    )}
                </CardBody>
            )}
            {!user && (<p>Please log in to power down.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header={cancel?"Stop Power Down":"Withdraw Steem Power"}
        >
            {renderForm}
            <AppModal isShowing={showConfirm} hide={() => !isCanceling && setShowConfirm(false)} size="md" header={cancel ? "Confirm Stop Power Down" : "Confirm Power Down"}>
                <div className="p-3 text-scheme">
                    <p className="text-muted">
                        {transferAmount === 0 
                            ? "You are about to stop your current power down." 
                            : "You are about to start a power down. Please review the details:"}
                    </p>
                    {transferAmount > 0 && (
                        <div className="mb-4 p-3 border rounded bg-speem-confirm">
                            <div className="mb-2">
                            <i className="fas fa-coins mr-2 text-speem" /> <strong>Total Amount:</strong> <span className="ml-2">{parseFloat(transferAmount).toFixed(3)} SP</span>
                            </div>
                            <div className="mb-0">
                            <i className="fas fa-calendar-alt mr-2 text-speem" /> <strong>Weekly payout:</strong> <span className="ml-2">{(transferAmount / 4).toFixed(3)} SP / week</span>
                            </div>
                        </div>
                    )}
                    <div className="d-flex gap-3 mt-4">
                        <Button color="secondary" onClick={() => setShowConfirm(false)} disabled={isCanceling} className="w-100 mr-2 btn-fancy">
                            Cancel
                        </Button>
                        <Button color="default" onClick={() => handlePD()} disabled={isCanceling} className="w-100 btn-fancy position-relative">
                            {isCanceling ? (
                                <span className="spinner dark m-0" />
                            ) : keychainLogin ? (
                                <>
                                Confirm with
                                <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" />
                                </>
                            ) : (
                                "Confirm"
                            )}
                        </Button>
                    </div>
                </div>
            </AppModal>
        </AppModal>
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => { 
                if (wif) {
                handlePD(wif);
                } 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default PowerDownModal;